import * as React from "react"
import type { SVGProps } from "react"
const SvgLayoutList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M5 9.57v-4h14v4zm0 10h14v-4H5zm-1.4-8.59q.59.6 1.41.6h14q.83 0 1.41-.6.6-.59.59-1.4v-4q0-.84-.59-1.42A2 2 0 0 0 19 3.57H5q-.82 0-1.41.59A2 2 0 0 0 3 5.57v4q0 .82.59 1.41m0 10q.59.6 1.41.6h14q.83 0 1.41-.6.6-.59.59-1.4v-4q0-.84-.59-1.42a2 2 0 0 0-1.41-.59H5q-.82 0-1.41.59A2 2 0 0 0 3 15.57v4q0 .82.59 1.41"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgLayoutList
